// The menu burger sits where the panels dock: outside, as its own round button left of the search bar, from 1024 px; as the first
// symbol inside the search bar on phones and tablets. One element moves between the two places, so its id, listeners and focus handling stay.
import {WIDE_QUERY, isWide} from './layout.mjs';

export const dockFor = (win = globalThis) => (win.matchMedia ? isWide(win) : true) ? 'outside' : 'bar';
export const menuButtonClass = dock => dock === 'outside' ? 'btn-icon fab menu-burger' : 'btn-icon search-menu';
export function installDock({doc = document, win = globalThis} = {}) {
  const button = doc.getElementById('menu-button'), root = doc.getElementById('place-search'), field = root?.querySelector('.search-field');
  if (!button || !field) return null;
  const place = () => {
    const dock = dockFor(win), had = doc.activeElement === button;
    button.className = menuButtonClass(dock); button.dataset.dock = dock;
    // Moving the node drops its focus; the burger keeps it. Both homes put it first in tab order, before the search input.
    if (dock === 'outside') { if (button.nextElementSibling !== root) root.before(button); }
    else if (field.firstElementChild !== button) field.prepend(button);
    if (had && doc.activeElement !== button) button.focus({preventScroll: true});
  };
  const query = win.matchMedia?.(WIDE_QUERY);
  query?.addEventListener?.('change', place);
  place();
  return {place};
}
